import PropTypes from 'prop-types'

import { ChildrenSchema } from 'utils'

import { NOTIFICATIONS_STATUS } from '../constants'

export default PropTypes.shape({
  id: ChildrenSchema.isRequired,

  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
      text: PropTypes.string.isRequired,
    }),
  ),
  children: ChildrenSchema,
  className: PropTypes.string,
  dismissAfter: PropTypes.number,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  onDismiss: PropTypes.func,
  status: PropTypes.oneOf(Object.keys(NOTIFICATIONS_STATUS)),
  title: ChildrenSchema,
})
